module.exports = __webpack_public_path__ + "f8a8c0717c7f3277b5d8551db432f8e9.svg";